import React,{useEffect, useState  } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Steps, Panel, Placeholder, ButtonGroup, Button } from 'rsuite';
import AddEvent from './addEvent';
import { message } from "antd";

const EventLayOutAdd = () => {
  const [step, setStep] = useState(0);
  const onChange = nextStep => {
    setStep(nextStep < 0 ? 0 : nextStep > 2 ? 2 : nextStep);
  };

  const onNext = () => onChange(step + 1);
  const onPrevious = () => onChange(step - 1);



    let navigate = useNavigate();


    useEffect(() => {

            const role = localStorage.getItem('userrole');
            if(role ==="SUPERADMIN"){

            }else{
                message.success('You are not authorized to perform this action.');
                navigate('/admin')
            }


    }, []);



  return (

        <div>
            <aside class="right-side areas">
                <div class="content-area dash-contentss">

                <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Create Seminar</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/conference">Seminar</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Create Seminar</li>
                        </ol>
                    </nav>




            <AddEvent />



            {/* <ButtonGroup>
                    <Button className="button-focus"  onClick={onPrevious} disabled={step === 0}>
                        Previous
                    </Button>
                {step === 2?
                    <Button appearance="primary" className="button-focus" onClick={onNext} disabled={step === 1}>
                        Create Event
                    </Button>:
                    <Button appearance="primary" className="button-focus" onClick={onNext} disabled={step === 2}>
                        Next
                    </Button>
                }
            </ButtonGroup> */}




                </div>
            </aside>
        </div>
      
  );
};

export default EventLayOutAdd;